export default {
  enums: [
    { id: 'AGGREGATION' },
    { id: 'DISAGGREGATION' },
    { id: 'REMOVING' },
    { id: 'ADDING' },
    { id: 'SETS_AGGREGATION' },
  ]
};